<script>

import PageViewsTable from './PageViewsTable';

export default {
  components: { PageViewsTable },
  data() {
    return {
      dateRange: { startDate: this.moment().subtract(6, 'days').startOf('day').toDate(), endDate: this.moment().endOf('day').toDate() },

      current_pageview: [],

      loading: true,
      results: [],
      pagination: {},
      filters: {
        paginate: 100,
        page: 1,
        total: 0,
        betweens: {
          created_at: {
            start: '',
            end: ''
          }
        },
        whereins: {
          website: [],
        },
      },
    }
  },
  watch: {
    'dateRange': { handler: function(n, o) {
      if(n.startDate && n.endDate && this.moment(n.startDate).isValid() && this.moment(n.endDate).isValid()) {
        this.filters.betweens.created_at.start = this.moment(n.startDate).startOf('day').format();
        this.filters.betweens.created_at.end = this.moment(n.endDate).endOf('day').format();
      } else {
        this.filters.betweens.created_at.start = '';
        this.filters.betweens.created_at.end = '';
      }
      this.fetchData();
    }, deep: true },
  },
  created() {
    this.filters.whereins.website = [this.website_id];
    this.filters.betweens.created_at.start = this.moment(this.dateRange.startDate).startOf('day').format();
    this.filters.betweens.created_at.end = this.moment(this.dateRange.endDate).endOf('day').format();

    this.fetchData();
  },
  mounted() {
    window.addEventListener('scroll', this.setStickyNav);
    window.addEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').addEventListener('scroll', this.setStickyNav); }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setStickyNav);
    window.removeEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').removeEventListener('scroll', this.setStickyNav); }
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.filters.page = this.pagination.current_page;
      this.$http.get('/api/pageviews/userjourney', {params: this.filters}).then(res => {
        // console.log(res);
        this.results = res.data;
        // this.pagination = res.data;
        // this.filters.total = res.data.total;
        this.loading = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
    getUserArray(views) {
      var users = [];
      var output = "";
      // console.log(views);
      for(var i in views) {
        if(views[i].user && !users[views[i].user.name]) {
          users[views[i].user.name] = "1";
          if(!output) { output = output+""+views[i].user.name; } else { output = output+", "+views[i].user.name; }

        }
      }
      return output;
    }

  }
}
</script>

<template>
  <div class="card-box p-0 position-relative">

    <div v-if="current_pageview.length" key="1">

      <div class="p-4">
        <span class="h4 header-title _c-pointer " @click="current_pageview = []"><Icon icon="ri:arrow-left-line" /> Return to list</span>
        <div class="float-right">
          <span class="p-1 bg-light border rounded mr-1"><strong>IP:</strong> {{current_pageview[0].ip}}</span>
          <span class="p-1 bg-light border rounded mr-1"><strong>Connected user(s):</strong> {{getUserArray(current_pageview)}}</span>
        </div>
      </div>

      <page-views-table v-if="current_pageview" :found="current_pageview"></page-views-table>

    </div>
    <div v-show="!current_pageview.length" key="2">

      <transition name="fade">
        <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
      </transition>
      <div class="row p-4">
        <div class="col-lg-12">

          <div class="float-right">
            <div class="form-inline">
              <w-field class="mr-2" SimpleDataType="String List, Multi" :Options="app_website_ids" v-model="filters.whereins.website" placeholder="Websites..." @input="fetchData()" :Disabled="loading"></w-field>
              <w-field SimpleDataType="Date range" v-model="dateRange" placeholder="Filter by date created..." :Disabled="loading"></w-field>
            </div>
          </div>
          <ul class="list-inline m-0 small">
            <li class="list-inline-item alert alert-warning mb-0 px-3 py-2">Paid AD</li>
            <li class="list-inline-item alert alert-danger mb-0 px-3 py-2">Possible Search Bot</li>
            <li class="list-inline-item alert alert-info mb-0 px-3 py-2">Direct IP</li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="table-responsive m-0">
            <table class="table table-small sticky-header table-bordered-right table-hover mb-0 table-centered text-nowrap">
              <thead class="bg-white">
                <tr>
                  <th class="font-weight-medium">IP Address</th>
                  <th class="font-weight-medium">Page Views</th>
                  <th class="font-weight-medium">First Entry</th>
                  <th class="font-weight-medium">Last Entry</th>
                </tr>
                <tr class="sticky-thead bg-white">
                  <th class="font-weight-medium">IP Address</th>
                  <th class="font-weight-medium">Page Views</th>
                  <th class="font-weight-medium">First Entry</th>
                  <th class="font-weight-medium">Last Entry</th>
                </tr>
              </thead>
              <tbody class="">
                <tr v-for="(item, index) in results" :key="item.id" class="_c-pointer" @click="current_pageview = item" :class="
                  item.some(e => e.user_agent && e.user_agent.includes('bot') ) ? 'alert-danger' :
                  item.some(e => e.query_string && e.query_string.includes('utm_source=cox') ) ||
                  item.some(e => e.query_string && e.query_string.includes('gclid=') ) ? 'alert-warning' :
                  item.some(e => e.domain && e.domain.includes('52.9.195.63') ) ? 'alert-info' : ''
                  ">
                  <td>{{index}} <span class="text-primary">{{getUserArray(item)}}</span></td>
                  <td>{{item.length}}</td>
                  <td v-tippy :content="moment(item[item.length-1].created_at).format('lll')">{{moment(item[item.length-1].created_at).fromNow()}}</td>
                  <td v-tippy :content="moment(item[0].created_at).format('lll')">{{moment(item[0].created_at).fromNow()}}</td>
                </tr>
              </tbody>
            </table>
            <div class="p-2 border-top border-light">
              <w-pagination :pagination="pagination" @paginate="results=[]; fetchData()" :offset="4"></w-pagination>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>
